import React from 'react';
// bundleLoader
import BundleLoader from 'lm-bundle-loader';
import {
    Route,
    Switch,
    Redirect,
    withRouter
} from 'react-router-dom';

import { titleList } from './titleConfig.js';
import { isWechat, isInsureApp, weChatFn, bridge, rrwebUpload, sqbSession } from '@sqb/utility';
import { deleteSkeleton } from 'api/deleteSkeleton.js';
import { Toast } from 'antd-mobile';
import pageLogin from 'tools/utils/libs/pageLogin';
import visitReport from 'tools/utils/libs/visitReport';

// 异步加载文件 参考文档 https://webpack.js.org/guides/code-splitting/#dynamic-imports
// 参数中的注释部分不建议删除，原因请看上述文档
const Index = () => import( './Index' /* webpackChunkName:"Index" */ );
const Notify = () => import( './Notify' /* webpackChunkName:"Notify" */ );
const Insure = () => import( './Insure' /* webpackChunkName:"Insure" */ );
const GuaranteeDetail = () => import( './GuaranteeDetail' /* webpackChunkName:"GuaranteeDetail" */ );
const PromotionMaterials = () => import('./PromotionMaterials' /* webpackChunkName:"PromotionMaterials" */);
const MaterialsList = () => import('./MaterialsList' /* webpackChunkName:"MaterialsList" */);
const MaterialDetail = () => import('./MaterialDetail' /* webpackChunkName:"MaterialDetail" */);
const PayResult = () => import('./PayResult' /* webpackChunkName:"PayResult" */);
const ToPayResult = () => import('./ToPayResult' /* webpackChunkName:"PayResult" */);
const Protocol = () => import('./Protocol' /* webpackChunkName:"Protocol" */);
const VisitOnline = () => import('./VisitOnline' /* webpackChunkName:"VisitOnline" */);
const NotFound = () => import('pagecommon/containers/NotFound' /* webpackChunkName:"VisitOnline" */);
const NewIndex = () => import( './NewIndex' /* webpackChunkName:"NewIndex" */ );

sqbSession();

class MainRouter extends React.Component {
    componentDidMount(){
        this.rrwebRecord();
        deleteSkeleton();
        this.setTitle();
        isWechat() && weChatFn.init();

        pageLogin();
        visitReport();
    }

    rrwebRecord = () => {
        // 页面刷新，会走到mainRouter 这时候需要将rrweb的sqbSessionStorage清除掉
        // window.sqbSessionStorage.removeItem('rrwebIsIn');
        rrwebUpload.getInstance({ wait: 1500 }).subscribe().upload();
    }

    setTitle = ()=>{
        // 解决当请求中时，用户直接点击回退，loading不消失
        Toast.hide();
        let name = this.props.location.pathname;
        for (let key in titleList) {
            if (name.toLowerCase().indexOf(key) > -1) {
                bridge.setTitle(titleList[key].title);
                isInsureApp() && window.WBAPP.invoke('set_title', titleList[key]);
                break;
            }
        }
    }

    componentDidUpdate(){
        this.setTitle();
        isWechat() && weChatFn.init();
        pageLogin();
        visitReport();
    }

    render(){
        return (
            <Switch>
                <Route path='/product/index/:productId/:userid?' render={(props) => BundleLoader(Index, props)}/>
                <Route path='/product/notify/:productId/:detailCode/:formJsonId/:premium' render={(props) => BundleLoader(Notify, props)}/>
                <Route path='/product/insure/:productId/:detailCode/:formJsonId/:premium' render={(props) => BundleLoader(Insure, props)}/>
                <Route path='/product/guaranteedetail/:productId' render={(props) => BundleLoader(GuaranteeDetail, props)}/>
                <Route path='/product/promotionmaterials/:productId' render={(props) => BundleLoader(PromotionMaterials, props)}/>
                <Route path='/product/materialslist/:productId/:documentType' render={(props) => BundleLoader(MaterialsList, props)}/>
                <Route path='/product/materialdetail' render={(props) => BundleLoader(MaterialDetail, props)}/>
                <Route path='/product/payresult/:orderId?' render={(props) => BundleLoader(PayResult, props)}/>
                <Route path='/product/ToPayResult/:orderId?' render={(props) => BundleLoader(ToPayResult, props)}/>
                <Route path='/product/protocol' render={(props) => BundleLoader(Protocol, props)}/>
                <Route path='/product/visitonline/:orderId' render={(props) => BundleLoader(VisitOnline, props)}/>
                <Route path='/product/notfound' render={(props) => BundleLoader(NotFound, props)}/>
                <Route path='/product/newindex/:productId/:userid?' render={(props) => BundleLoader(NewIndex, props)}/>
                <Redirect to='/product/notfound'/>
            </Switch>
        );
    }
}

export default withRouter(MainRouter);
